import React, {createContext, useCallback, useContext, useEffect, useMemo, useState} from 'react';
import availableLanguages from '@/translation/availableLanguages.json';

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import * as allLocale from 'date-fns/locale';
import {useTranslation} from "react-i18next";

import '@/i18n.js';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);
export const getStoredLanguage = () => {
    try {
        return localStorage.getItem('language') ?? availableLanguages[0];
    } catch (err) {
        return availableLanguages[0];
    }
};

export const LanguageProvider = ({children}) => {
    const { t, i18n } = useTranslation()
    const [language, _setLanguage] = useState(getStoredLanguage());

    useEffect(() => {
        for(const lang of availableLanguages){
            try{
                registerLocale(lang, allLocale?.[lang]);
            }catch(e){
                console.error(e);
            }
        }
    }, []);

    useEffect(() => {
        setDefaultLocale(language);
        i18n.changeLanguage(language).then();
    }, [language])

    const hourFormat = useMemo(() => {
        return language === 'fr' ? 'HH:mm' : 'hh:mm aa'
    }, [language])

    const setLanguage = useCallback((newLanguage) => {
        localStorage.setItem('language', newLanguage);
        i18n.changeLanguage(newLanguage).then();
        _setLanguage(() => newLanguage);
    }, []);

    /** getLangObject is an object with all available languages as keys, and empty string as values
     * ex: {fr: defaultValue', en: defautValue}
     */
    const getLangObject = useCallback((defaultValue = '') => {
        return Object.fromEntries(availableLanguages.map(lang => [lang, defaultValue]));
    }, []);

    return (
        <LanguageContext.Provider value={{t, setLanguage, language, availableLanguages, hourFormat, getLangObject}}>
            {children}
        </LanguageContext.Provider>
    );
};

export default LanguageProvider
